module.exports = __webpack_public_path__ + "static/media/advantages.821801e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/others/advantages.png
// module id = 1223
// module chunks = 0